var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryAndReportsBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3V2H8.5V3H5V22H19V3H15.5ZM9.5 3H14.5V4H9.5V3ZM18 21H6V4H8.5V5H15.5V4H18V21ZM10 7H17V8H10V7ZM15 10H10V9H15V10ZM7 8.5C7 7.94861 7.44861 7.5 8 7.5C8.55139 7.5 9 7.94861 9 8.5C9 9.05139 8.55139 9.5 8 9.5C7.44861 9.5 7 9.05139 7 8.5ZM17 14.5C17 15.0514 16.5514 15.5 16 15.5C15.4486 15.5 15 15.0514 15 14.5C15 13.9486 15.4486 13.5 16 13.5C16.5514 13.5 17 13.9486 17 14.5ZM7 13H14V14H7V13ZM9 15H14V16H9V15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryAndReportsBlack);
export default __webpack_public_path__ + "static/media/history-and-reports-black.77b8f44907d69aec9db9a7f0a5677ccd.svg";
export { ForwardRef as ReactComponent };